



















import Vue, { PropType } from 'vue'
import { MapPosition, MapMarker } from '@/interfaces/gmap/Map'
import { GoogleMapLoader, TransactionMapMarker } from '@/components/gmap/'

type TransactionMapProps = Array<{
  lat: number
  lng: number
  location: string
  priceAvg: number
  priceTotalAvg: number
}>

export default Vue.extend({
  props: {
    data: Array as PropType<TransactionMapProps>,
    center: Object as PropType<MapPosition>,
    zoom: {
      type: Number,
      default: 15,
    },
    zoomControl: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    GoogleMapLoader,
    TransactionMapMarker,
  },
  data() {
    return {
      mapConfig: {
        center: { lat: this.center.lat, lng: this.center.lng },
        zoom: this.zoom,
        zoomControl: this.zoomControl,
        mapTypeControl: false,
        mapTypeId: 'terrain',
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: false,
        styles: [
          {
            featureType: 'poi',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
        ],
      },
    }
  },
  computed: {
    markers() {
      let id = 1
      return this.data.map(d => {
        return {
          id: id++,
          position: { lat: d.lat, lng: d.lng },
          icon: require('@/assets/icons/map/pointer–blue.svg'),
          location: d.location,
          priceAvg: d.priceAvg,
          priceTotalAvg: d.priceTotalAvg,
        }
      })
    },
  },
})
